import classNames from 'classnames/bind';
import { DateFormat } from 'common/types';
import { days, isStayDuration } from 'common/utils';
import { useSearchParamsContext } from 'contexts/searchParams';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  className?: string;
  index: number;
  multiCity?: boolean;
  clickCodePrefix: string;
  isMultiCityExpanded?: boolean;
  onClick(): void;
}

export default function DepartureDate({
  className,
  index,
  multiCity,
  clickCodePrefix,
  isMultiCityExpanded,
  onClick,
}: IProps) {
  const {
    searchParams: { itinerary },
  } = useSearchParamsContext();
  const dateStr = itinerary[index]?.departureDate;
  const date =
    dateStr && !isStayDuration(dateStr)
      ? days(itinerary[index].departureDate, DateFormat.YMD).format(
          DateFormat.DotMDd,
        )
      : null;

  const dateSummary = itinerary
    .map((itin, index) => {
      const dateStr = itin?.departureDate;
      return dateStr && !isStayDuration(dateStr)
        ? days(itin.departureDate, DateFormat.YMD).format(DateFormat.DotMDd)
        : `${index + 1}여정`;
    })
    .join(' / ');

  return (
    <button
      type="button"
      className={cx(className, {
        DepartureDate: multiCity,
        Date: !multiCity,
      })}
      aria-selected={!!date}
      data-event-nlog="click"
      data-event-area-code={`${clickCodePrefix}.depdate${index + 1}`}
      onClick={onClick}
    >
      {multiCity ? ( //
        <i className={cx('txt')}>
          {isMultiCityExpanded ? date || `${index + 1}여정` : dateSummary}
        </i>
      ) : (
        date || `${index === 0 ? '가는' : '오는'} 날`
      )}
    </button>
  );
}
